import React from "react";
import { connect } from "react-redux";
import { normalizeMoney, formatDate, required } from "../utility";
import { reduxForm, Field, formValueSelector, change } from "redux-form";
import { MaterialTextField, MaterialCheckbox } from "./MaterialInput";
import transactionForm from "./TransactionForm";
import InfoInput from "./InfoInput";
import TransactionTable from "./TransactionTable";
import * as agent from "../agent";
import { CONTRACT_CLOSED, MESSAGE_SENDED } from "../constants/actionTypes";
import { Dates, Transaction } from "../constants/enums";
import { calculateDelta,
         calculateSumPerDay,
         calculatePayedDays,
         calculateUsedDays,
         calculatePenalty,
         calculateBalance,
         calculatePaymentDebt,
         calculateActualRate,
         calculateRecommendedSum,
         calculateRecommendedSumLT,
         generateLeasingPayments } from "../businessLogic";
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import PrintLink from './PrintLink';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const TransactionForm = connect(
    (state, props) => {
        const { sum, programType, isLeasing, leasingPaymentBuyout, operations } = props;
        const closeOperation = operations.find(o => o.alias === Transaction.OperationCloseAliases[programType]) || {};
        const { mustHaveContract, mustHaveDepartment } = closeOperation;
        return {
            mustHaveContract,
            mustHaveDepartment,
            initialValues: {
                manager: state.common.user.id,
                paymentDate: formatDate(new Date()),
                operation: closeOperation._id,
                sum: normalizeMoney(`${isLeasing ? leasingPaymentBuyout : sum}`),
                vat: 0
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

class closeContract extends React.Component {

    state = {
        printed: false,
        printingReceipt: false,
        printReceipt: false,
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
    };
    fireError = e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } });
    componentWillMount = () => {
        const { isJuridicalPerson } = this.props;
        agent.User.managers(isJuridicalPerson)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(this.fireError);
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(this.fireError);
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(this.fireError);
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(this.fireError);
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showingModal: true})
    }
    setPrintFlag = () => this.setState({ printed: true })
    dropPrintFlag = () => this.setState({ printed: false })
    handleClose = () => this.setState({ showingModal: false})
    addTransaction = (data) => {
        const { operations, transactions } = this.state;
        const {
            inputPayment,
            sum,
            inputPenalty,
            programType,
            balance,
            inputRefund,
            isLeasing,
            leasingPaymentBuyout,
            isLastMonthProlongated,
            dispatch } = this.props;
        const closeContractSum = isLeasing ? leasingPaymentBuyout : sum;
        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions });
        const closeOperation = operations.find(o => o.alias === Transaction.OperationCloseAliases[programType]) || {};
        const prolongationOperation = operations.find(o => o.alias === Transaction.OperationProlongationAliases[programType]) || {};
        const penaltyOperation = operations.find(o => o.alias === "CONTRACT_PENALTY") || {};
        const refundOperation = operations.find(o => o.alias === "CONTRACT_REFUND") || {};
        const prolongationTSum = updTransactions.reduce((p, n) => p + +(n.operation === prolongationOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const closeTSum = updTransactions.reduce((p, n) => p + +(n.operation === closeOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const penaltyTSum = updTransactions.reduce((p, n) => p + +(n.operation === penaltyOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const refundTSum = updTransactions.reduce((p, n) => p + +(n.operation === refundOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const closePayed = closeTSum === closeContractSum;
        const prolongationPayed = isLastMonthProlongated ? true : prolongationTSum === inputPayment;
        const penaltyPayed = inputPenalty > 0 ? penaltyTSum === inputPenalty : true;
        const refundPayed = inputRefund ? refundTSum === balance : true;

        const nextOperation =
            closePayed ?
                (prolongationPayed ?
                    (penaltyPayed ?
                        (refundPayed ?
                            closeOperation._id
                            :
                            refundOperation._id
                        )
                        :
                        penaltyOperation._id
                    )
                    :
                    prolongationOperation._id
                )
                :
                closeOperation._id;

        dispatch(change("transaction-form", "sum", normalizeMoney(Math.max( closePayed ? (prolongationPayed ? ( penaltyPayed ? refundPayed ? 0 : balance - refundTSum : inputPenalty - penaltyTSum) : inputPayment - prolongationTSum ) : closeContractSum - closeTSum, 0))));
        dispatch(change("transaction-form", "operation", nextOperation ));

    }
    deleteTransaction = (index) => {
        const { transactions } = this.state;
        this.setState({ transactions: transactions.filter((_, i) => i !== index) })
    }
    processTransactions = (transactions, operations, accounts = []) => {
        return transactions.map(t => {
            const fOperation = operations.find(o => o._id === t.operation) || {};
            const fAccount = accounts.find(a => a._id === t.account) || {};
            return Object.assign(
                {...t},
                {sum: {"DEBIT": 1, "CREDIT": -1}[fOperation.side] * Number(t.sum.replace(/\s/g,``))},
                {alias: fOperation.alias},
                {accountType: fAccount.type}
            );
        });
    };
    printCloseReceipt = (e, office) => {
        e.preventDefault();
        this.setState({ printingReceipt: true });
        const { _id, userCredentials } = this.props;
        const { accounts, operations, transactions } = this.state;
        agent.Websocket.close(_id, office, userCredentials, this.processTransactions(transactions, operations, accounts))
            .then(res => {
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Чек распечатан", type: "success" } });
                this.setState({ printingReceipt: false, receiptPrinted: true });
            })
            .catch((e) => {
                this.setState({ printingReceipt: false });
                this.fireError(e);
            });
    }
    printPenaltyReceipt = (e, office) => {
        e.preventDefault();
        this.setState({ printingReceipt: true });
        const { _id, userCredentials } = this.props;
        const { accounts, operations, transactions } = this.state;
        agent.Websocket.penalty(_id, office, userCredentials, this.processTransactions(transactions, operations, accounts))
            .then(res => {
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Чек распечатан", type: "success" } });
                this.setState({ printingReceipt: false, receiptPrinted: true });
            })
            .catch((e) => {
                this.setState({ printingReceipt: false });
                this.fireError(e);
            });
    }

    render() {
        const { _id,
                inputPenalty,
                inputPayment,
                inputRefund,
                isLT,
                isAdmin,
                isLeasing,
                exemptionDate,
                usedDays,
                paymentDebt,
                balance,
                programType,
                recommendedSum,
                penalty,
                loanTicket,
                manager,
                isJuridicalPerson,
                sum,
                duration,
                paymentsLength,
                penaltySum,
                sumPerDay,
                leasingPaymentBuyout,
                isLastMonthProlongated,
                userOfficeMoscow,
                userOfficeNewcherkassky,
                onContractClose,
                handleSubmit } = this.props;
        const { showingModal,
                transactions,
                printed,
                printingReceipt,
                managers,
                managersLoaded,
                counterparties,
                counterpartiesLoaded,
                accounts,
                accountsLoaded,
                operations,
                operationsLoaded } = this.state;
        const closeContractSum = isLeasing ? leasingPaymentBuyout : sum;
        const total = inputPenalty + closeContractSum + (isLastMonthProlongated ? 0 : inputPayment) - (inputRefund ? balance : 0 );
        const closeOperation = operations.find(o => o.alias === Transaction.OperationCloseAliases[programType]) || {};
        const prolongationOperation = operations.find(o => o.alias === Transaction.OperationProlongationAliases[programType]) || {};
        const penaltyOperation = operations.find(o => o.alias === "CONTRACT_PENALTY") || {};
        const refundOperation = operations.find(o => o.alias === "CONTRACT_REFUND") || {};
        const prolongationTransactions = transactions.filter(t => t.operation === prolongationOperation._id);
        const penaltyTransactions = transactions.filter(t => t.operation === penaltyOperation._id);
        const closeTransactions = transactions.filter(t => t.operation === closeOperation._id);
        const refundTransactions = transactions.filter(t => t.operation === refundOperation._id);
        const sumTransactions = (transactions) => transactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const prolongationTSum = sumTransactions(prolongationTransactions);
        const penaltyTSum = sumTransactions(penaltyTransactions);
        const closeTSum = sumTransactions(closeTransactions);
        const refundTSum = sumTransactions(refundTransactions);

        const allowedOperations = [Transaction.OperationCloseAliases[programType]].concat(isLastMonthProlongated ? inputRefund ? ["CONTRACT_REFUND"] : [] : [Transaction.OperationProlongationAliases[programType]]).concat(inputPenalty > 0 ? ["CONTRACT_PENALTY"] : []);
        const submitDisabled = ((isLastMonthProlongated ? (inputRefund ? balance === refundTSum : true) : inputPayment === prolongationTSum) && closeContractSum === closeTSum && inputPenalty === penaltyTSum);

        const prolongationDays = inputPayment / sumPerDay ^ 0;

        const prepareData = data => Object.assign(data, {
            payment: Number(data.payment.replace(/\s/g,``)),
            penalty: Math.max(inputPenalty - penaltySum, 0),
            newPenaltySum: Math.max(penaltySum - (inputPenalty - penalty), 0)
        });

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form >
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-column common-form">
                            <Field component={MaterialTextField}
                                   select
                                   disabled={!isAdmin}
                                   onChange={this.dropPrintFlag}
                                   validate={required}
                                   name="manager"
                                   label={isJuridicalPerson ? "Сторона договора" : "Менеджер"}>
                                   {managers.map(({ _id, fullname}, i) => {
                                       const [ managerLastname, managerFirstname = "", managerThirdname = "" ] = fullname.split(" ");
                                       return <MenuItem key={i} value={_id}>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                                   })}
                            </Field>
                            <InfoInput label="Сумма займа"
                                       endAdornment="₽"
                                       placeholder={normalizeMoney(sum)} />

                            {isLeasing &&
                                <InfoInput label="Срок лизинга"
                                           placeholder={duration} />
                            }
                            {isLeasing &&
                                <InfoInput label="Оплачено месяцев"
                                           placeholder={paymentsLength} />
                            }
                            {isLeasing &&
                                <InfoInput label="Сумма досрочного выкупа"
                                           endAdornment="₽"
                                           placeholder={normalizeMoney(leasingPaymentBuyout)} />
                            }
                            {isLT &&
                                <InfoInput label="Дата льготного периода"
                                           placeholder={formatDate(exemptionDate)} />
                            }
                            {isLT &&
                                <InfoInput label="Дней пользования"
                                           placeholder={usedDays} />
                            }
                            {isLT &&
                                <InfoInput label="Залоговый билет №"
                                           placeholder={loanTicket} />
                            }
                            {!isLastMonthProlongated &&
                                <Field component={MaterialTextField}
                                       name="payment"
                                       normalize={normalizeMoney}
                                       FormHelperTextProps={{ classes: {root: "input-error"} }}
                                       format={normalizeMoney}
                                       helperText={` / ${sumPerDay.toFixed(2)} = ${prolongationDays} дней`}
                                       endAdornment="₽"
                                       label="Рекомендованная сумма" />
                            }
                            <InfoInput label="Итого"
                                       endAdornment="₽"
                                       placeholder={normalizeMoney(total)} />
                        </Grid>
                        <Grid item className="common-column common-form">
                            {(!isLT && !isLeasing) &&
                                <InfoInput label="Сумма штрафов"
                                           endAdornment="₽"
                                           placeholder={normalizeMoney(penaltySum)} />
                            }
                            {(!isLT && !isLeasing) &&
                                <InfoInput label="Штраф за просрочку"
                                           endAdornment="₽"
                                           placeholder={normalizeMoney(penalty)} />
                            }
                            {isLastMonthProlongated &&
                                <InfoInput label="Предоплачено"
                                           endAdornment="₽"
                                           placeholder={normalizeMoney(balance)} />
                            }
                            {isLastMonthProlongated &&
                                <FormControlLabel
                                 control={
                                     <Field name="refundBalance"
                                            component={MaterialCheckbox} />}
                                 label="Возвратить предоплату"/>
                            }
                            {!isLastMonthProlongated &&
                                <InfoInput label="Задолженность"
                                           endAdornment="₽"
                                           placeholder={normalizeMoney(paymentDebt)} />
                            }
                            {!isLeasing &&
                                <Field component={MaterialTextField}
                                       onChange={this.dropPrintFlag}
                                       name="penaltyTotal"
                                       normalize={normalizeMoney}
                                       format={normalizeMoney}
                                       endAdornment="₽"
                                       helperText={`${inputPenalty > 0 ? `= ${normalizeMoney(Math.min(penalty, inputPenalty))} ₽ (за текущий период)` : ""}
                                                    ${inputPenalty > penalty && penaltySum > 0 ? `+ ${normalizeMoney(Math.min(inputPenalty - penalty, penaltySum))} ₽ (погашение долга по штрафам)` : ""}
                                                    ${inputPenalty > penalty + penaltySum ? `+ ${normalizeMoney(inputPenalty - penalty - penaltySum)} ₽ (прочие санкции)` : ""}
                                                    ${inputPenalty < penalty + penaltySum ? `[ ! ] Будет списано ${normalizeMoney(penalty + penaltySum - inputPenalty )} ₽ штрафов` : ""}`}
                                       label="Взыскать штрафы" />
                            }
                        </Grid>
                    </Grid>
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-column common-form">
                            {isLT ?
                                <PrintLink href={agent.src.printNew("buyout",_id, manager)}
                                           action={this.setPrintFlag}
                                           label="ЗБ Выкуп" /> :
                                <PrintLink href={agent.src.printNew("close_act",_id, manager)}
                                           action={this.setPrintFlag}
                                           label="Акт закрытия" />
                            }
                            {isLT ?
                                <PrintLink href={agent.src.printLT("lt_order", _id, (sum+inputPayment+inputPenalty), manager)}
                                           action={this.setPrintFlag}
                                           label="Приходный ордер" /> :
                                <PrintLink href={agent.src.printNew("close_extra",_id, manager)}
                                           action={this.setPrintFlag}
                                           label="Доп. соглашение" />
                            }
                            {isLT &&
                                <PrintLink href={agent.src.printNew("close_act", _id, manager)}
                                           action={this.setPrintFlag}
                                           label="Акт приема-передачи" />
                            }
                            {isLeasing &&
                                <PrintLink href={agent.src.print("leasing_buyout", _id)}
                                           action={this.setPrintFlag}
                                           label="Договор выкупа ТС" />
                            }
                        </Grid>
                        <Grid item className="common-column common-form">
                            <Button type="submit"
                                    onClick={this.handleClick}
                                    title={printed ? "" : "Распечатайте документы"}
                                    disabled={!printed}
                                    style={{ height: 49 }}
                                    fullWidth
                                    color="primary"
                                    size="large"
                                    variant="contained">Закрыть займ</Button>
                            <Dialog maxWidth={false} open={showingModal} onClose={this.handleClose}>
                                <Paper className="common-paper">
                                    <Grid container justify="center" spacing={16}>
                                        <Grid item className="common-column">
                                            <TransactionForm allowedOperations={allowedOperations}
                                                              addTransaction={this.addTransaction}
                                                              isAdmin={isAdmin}
                                                              contractMode={true}
                                                              managersLoaded={managersLoaded}
                                                              managers={managers}
                                                              programType={programType}
                                                              accounts={accounts}
                                                              accountsLoaded={accountsLoaded}
                                                              counterparties={counterparties}
                                                              counterpartiesLoaded={counterpartiesLoaded}
                                                              operations={operations}
                                                              operationsLoaded={operationsLoaded}
                                                              contractId={_id}
                                                              sum={closeContractSum} />
                                        </Grid>
                                        <Grid item className="maxwide-column">
                                            <Typography>*Для закрытия займа необходимо: </Typography>
                                            <Typography>1. Провести одну или несколько транзакций закрытия займа на сумму {normalizeMoney(closeContractSum)} ₽</Typography>
                                            {!isLastMonthProlongated && <Typography>2. Провести одну или несколько транзакций пролонгации за последний месяц пользования займом на сумму {normalizeMoney(recommendedSum)} ₽</Typography>}
                                            {inputPenalty > 0 && <Typography>{isLastMonthProlongated ? "2" : "3" }. Провести одну или несколько транзакций оплаты штрафов на сумму {normalizeMoney(inputPenalty)} ₽</Typography>}
                                            <Typography>Вы добавили {closeTransactions.length} операций закрытия займа на сумму {normalizeMoney(closeTSum)} ₽</Typography>
                                            {closeTSum > closeContractSum && <Typography>Сумма транзакций превышает сумму закрытия займа на {normalizeMoney(closeTSum - closeContractSum)} ₽. Удалите одну или несколько транзакций закрытия займа</Typography>}
                                            {closeTSum < closeContractSum && <Typography>Cумма закрытия займа превышает сумму транзакций на {normalizeMoney(closeContractSum - closeTSum)} ₽. Добавьте одну или несколько транзакций закрытия займа</Typography>}
                                            {!isLastMonthProlongated && <Typography>Вы добавили {prolongationTransactions.length} операций пролонгации займа на сумму {normalizeMoney(prolongationTSum)} ₽</Typography>}
                                            {!isLastMonthProlongated && prolongationTSum > inputPayment && <Typography>Сумма транзакций превышает сумму пролонгации займа на {normalizeMoney(prolongationTSum - inputPayment)} ₽. Удалите одну или несколько транзакций пролонгации займа</Typography>}
                                            {!isLastMonthProlongated && prolongationTSum < inputPayment && <Typography>Cумма пролонгации займа превышает сумму транзакций на {normalizeMoney(inputPayment - prolongationTSum)} ₽. Добавьте одну или несколько транзакций пролонгации займа</Typography>}
                                            {inputPenalty > 0 && <Typography>Вы добавили {penaltyTransactions.length} операций оплаты штрафов на сумму {normalizeMoney(penaltyTSum)} ₽</Typography>}
                                            {inputPenalty > 0 && penaltyTSum > inputPenalty && <Typography>Сумма транзакций превышает сумму оплаты штрафов на {normalizeMoney(penaltyTSum - inputPenalty)} ₽. Удалите одну или несколько транзакций оплаты штрафов</Typography>}
                                            {inputPenalty > 0 && penaltyTSum < inputPenalty && <Typography>Cумма оплаты штрафов превышает сумму транзакций на {normalizeMoney(inputPenalty - penaltyTSum)} ₽. Добавьте одну или несколько транзакций оплаты штрафов</Typography>}
                                            {inputRefund && <Typography>Вы добавили {refundTransactions.length} операций оплаты штрафов на сумму {normalizeMoney(refundTSum)} ₽</Typography>}
                                            {inputRefund && refundTSum > balance && <Typography>Сумма транзакций превышает сумму возврата предоплаты на {normalizeMoney(refundTSum - balance)} ₽. Удалите одну или несколько транзакций возврата предоплаты</Typography>}
                                            {inputRefund && refundTSum < balance && <Typography>Cумма возврата предоплаты превышает сумму транзакций на {normalizeMoney(balance - refundTSum)} ₽. Добавьте одну или несколько транзакций возврата предоплаты</Typography>}
                                            {submitDisabled && <Typography>Cуммы транзакций совпадают. Операция может быть проведена</Typography>}
                                            <Typography>Чтобы изменить суммы операций закройте диалоговое окно</Typography>
                                            { transactions.length > 0 ?
                                                <TransactionTable transactions={transactions}
                                                                   accounts={accounts}
                                                                   counterparties={counterparties}
                                                                   operations={operations}
                                                                   onTransactionDelete={this.deleteTransaction} />
                                                :
                                                <Typography>Необходимо добавить транзакцию</Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                    {(isLeasing || isLT) && userOfficeNewcherkassky &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printCloseReceipt(e, "NEWCHERKASSKY")}
                                                        fullWidth
                                                        disabled={!submitDisabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек закрытие | НВЧ" }</Button>
                                                
                                            </Grid>
                                        </Grid>
                                    }
                                    {(isLeasing || isLT) && userOfficeMoscow &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printCloseReceipt(e, "MOSCOW")}
                                                        fullWidth
                                                        disabled={!submitDisabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек закрытие | МСК" }</Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    {isLeasing && penaltyTransactions.length > 0 && userOfficeNewcherkassky &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printPenaltyReceipt(e, "NEWCHERKASSKY")}
                                                        fullWidth
                                                        disabled={!submitDisabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек штраф | НВЧ" }</Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    {isLeasing && penaltyTransactions.length > 0 && userOfficeMoscow &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printPenaltyReceipt(e, "MOSCOW")}
                                                        fullWidth
                                                        disabled={!submitDisabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек штраф | МСК" }</Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid container spacing={16}>
                                        <Grid item className="common-column">
                                            <Button type="submit"
                                                    fullWidth
                                                    disabled={!submitDisabled}
                                                    onClick={handleSubmit(data => {
                                                        onContractClose(_id, prepareData(data), this.processTransactions(transactions, operations));
                                                        this.handleClose();
                                                    })}
                                                    size="large"
                                                    color="primary"
                                                    variant="contained" >Займ закрыт</Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Dialog>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        );
    }
}

const CloseContract = connect(
    state => {
        // input values from form
        const inputPayment = +`${formValueSelector("contract-close-form")(state, "payment")}`.replace(/\s/g,``);
        const inputPenalty = +`${formValueSelector("contract-close-form")(state, "penaltyTotal")}`.replace(/\s/g,``);
        const inputRefund = formValueSelector("contract-close-form")(state, "refundBalance");
        const manager = formValueSelector("contract-close-form")(state, "manager");
        // contract data from db
        const {carId, client, isJuridicalPerson} = state.client;
        const car = client.cars.find(c => c._id === carId);
        const {
            contract: {
                programDetails: {sum, duration, programType, rates, loanTicket = [], preferentialRepayment, preferentialPeriod, isLeasingPrepayed },
                sumLog,
                creationDate,
                prolongationDate,
                penaltySum,
                _id,
                payments
            } } = car;
        // calculated values
        const today = (new Date()).setHours(0,0,0,0);
        const cDate = (new Date(creationDate)).setHours(0,0,0,0);
        const pDate = (new Date(prolongationDate)).setHours(0,0,0,0);

        const isLT = programType === "HOLD_LT";
        const isPTS = programType === "PTS";
        const isLeasing = programType === "PTS_LEASING";
        const isLastMonthProlongated = isPTS;
        const actualRate = calculateActualRate(rates, payments.length);

        const sumPerDay = calculateSumPerDay(isLT, sum, actualRate);
        const payedDays = calculatePayedDays(pDate, today);
        const usedDays = calculateUsedDays(isLT, pDate, today);
        const paymentDebt = calculatePaymentDebt(sumPerDay, usedDays);
        const exemptionDate = new Date(+pDate + Dates._31Days + (isLT ? duration * Dates._1Day : 0 ));
        const balance = calculateBalance(payedDays, sumPerDay);

        const delta = calculateDelta(isLT, today, exemptionDate, pDate);
        const penalty = calculatePenalty(isLT, sum, delta);
        const penaltyTotal = penalty + penaltySum;
        // leasing values
        const paymentsPlan = generateLeasingPayments({
            date: cDate,
            duration,
            sumLog,
            leasingRate: rates[0],
            sum: sum,
            preferentialPeriod,
            isLeasingPrepayed: isLeasingPrepayed,
            isPreferentialRepayment: preferentialRepayment
        });

        const paymentsLength = payments.length;
        const recommendedSum = isLT ? calculateRecommendedSumLT(sumPerDay, usedDays) : calculateRecommendedSum(sumPerDay, usedDays); // instead of percents

        const leasingPaymentBuyout = paymentsLength > 0 ? (paymentsPlan[paymentsLength - 1] || paymentsPlan[paymentsPlan.length - 1]).paymentBuyout : sum;

        const [
            secondname = "",
            firstname = "",
            thirdname = ""
        ] = state.common.user.fullname.split(" ");

        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            userOfficeMoscow: state.common.user.officeMoscow,
            userOfficeNewcherkassky: state.common.user.officeNewcherkassky,
            userCredentials: `${secondname} ${firstname[0]}. ${thirdname[0]}.`,
            paymentsLength,
            loanTicket: loanTicket[0],
            manager,
            isJuridicalPerson,
            _id,
            inputPenalty,
            inputPayment,
            inputRefund,
            isLT,
            isLeasing,
            exemptionDate,
            usedDays,
            balance,
            recommendedSum,
            paymentDebt,
            penalty,
            programType,
            sum,
            duration,
            penaltySum,
            sumPerDay,
            leasingPaymentBuyout,
            isLastMonthProlongated,
            initialValues: {
                payment: normalizeMoney(recommendedSum),
                penaltyTotal: normalizeMoney(penaltyTotal),
                manager: state.common.user.id
            },
        };
    },
    dispatch => ({
        onContractClose: (contractId, data, transactions) =>
            agent.Contract.close(contractId, data, transactions)
            .then(contract => dispatch({type: CONTRACT_CLOSED, payload: contract})),
    })
)(reduxForm({
    form: "contract-close-form",
    enableReinitialize: true
})(closeContract));

export default CloseContract;



// WEBPACK FOOTER //
// ./src/components/CloseContract.js